import type { ListBuilderList } from '../../../types';

/**
 * False Block (PD-16228) — one of the quality classes the tenant value ledger
 * publishes (scripts/license-management/maintenance/active/tenant-value-ledger.mjs),
 * now a list a reviewer can act on instead of a number in a CLI report.
 *
 * We are refusing or chasing renewals on an account the board says is current — lost orders and wasted rep time. Republic, 2026-09-17: 4,249 licences, of which 3,470 carry a CONFIRMED registry link whose local expiry simply drifted (the registry-value re-apply is not scheduled) and 779 are unconfirmed suggestions.
 *
 * Backed by the locked `licenseRegistryGap: false_block` filter, which reads the
 * registry's own row through the licence's confirmed link OR through an
 * unconfirmed licence-number suggestion at 90%+ — the same rule as the Not
 * Usable card (PD-16225), because Tier-1 auto-confirm refuses to confirm onto a
 * row that disagrees with the licence on file, so waiting for a link would hide
 * the case entirely.
 *
 * Last sale newest first: the actively-buying account is the one to fix first.
 */
export const falseBlockList: ListBuilderList = {
	id: 'default-licenses-false-block',
	cacheTTL: 300000,
	name: 'False Block',
	type: 'default',
	active: true,
	sortOrder: 11,
	filterRules: {
		licenseRegistryGap: {
			defaultValue: [
				{
					id: 'false_block',
					label: 'False Block (we say expired, board says current)',
				},
			],
			locked: true,
			hidden: true,
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
